import { apiRequest } from '../../../shared/services/apiClient';
import type { MessageTemplate } from '../../conversations/services/conversationService';

export type ReminderMessageTemplate = MessageTemplate;

const templateBasePath = '/api/v1/conversations/templates';
const reminderScope = 'reminder';

export const listReminderMessageTemplates = (): Promise<ReminderMessageTemplate[]> =>
  apiRequest<ReminderMessageTemplate[]>(`${templateBasePath}?scope=${reminderScope}`);

export const createReminderMessageTemplate = (name: string, content: string): Promise<ReminderMessageTemplate> =>
  apiRequest<ReminderMessageTemplate>(templateBasePath, {
    method: 'POST',
    body: JSON.stringify({ name, content, scope: reminderScope }),
  });

export const updateReminderMessageTemplate = (
  id: string,
  name: string,
  content: string,
): Promise<ReminderMessageTemplate> =>
  apiRequest<ReminderMessageTemplate>(`${templateBasePath}/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify({ name, content }),
  });
